// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1iq3Q","right":"styles_right__2o-YL"};